 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-02c995b5":"5aedb4e0","chunk-09155df3":"121025b2","chunk-09162720":"45a67412","chunk-097e0872":"83dae8d5","chunk-0e93a01c":"47783e2d","chunk-19376720":"60133a79","chunk-2d0ddb6f":"26f3f664","chunk-3b2239ce":"c7b8cdff","chunk-3d383c98":"14afd033","chunk-41455109":"79ecd775","chunk-415b51d1":"92f84700","chunk-415bdaca":"6eaf0f3e","chunk-49735a2a":"96ae1302","chunk-5542dd67":"1cb896a2","chunk-5868e738":"85daf3c8","chunk-8511850a":"4c9f1b12","chunk-94c44d00":"dd9f9456","chunk-d8b4cf7c":"026ee73d","chunk-2d0ac06a":"0ff17344","chunk-36c4d051":"4233299f","chunk-1bc223c0":"52c6e32c","chunk-1bff95de":"096fa0c6","chunk-1c4705f4":"ceb3cbb1","chunk-1dbc15a2":"e9460232","chunk-21a76241":"eaedb0a9","chunk-25d83ca8":"7fe9a31f","chunk-2d0a463b":"929bc9f1","chunk-2d0ac3bc":"ee50f13c","chunk-2d0ac931":"17cfa0f8","chunk-2d0b6cad":"07bf30d6","chunk-2d0c073f":"9cb05e0c","chunk-2d0c211b":"ba545cf5","chunk-2d0cf315":"1ef6206f","chunk-2d0d32e6":"8a0e2ea2","chunk-2d0d43da":"648ff9e6","chunk-2d0d5c33":"28049a96","chunk-2d0da04a":"c960fda5","chunk-2d0e5812":"16f99d6f","chunk-2d0f0804":"6faa3428","chunk-2d213189":"2d0a3e5f","chunk-2d217def":"b35cd03e","chunk-2d217e6a":"21eb2a4b","chunk-2d218068":"a88b8818","chunk-2d21a9aa":"6003d65f","chunk-2d21da73":"b9907c55","chunk-2d222cca":"2219326e","chunk-2d22895d":"ca2e81cc","chunk-2d23721e":"db20ec86","chunk-2d237b00":"0cff8677","chunk-30dd9750":"2be7ab59","chunk-37f2300e":"b64301e0","chunk-3ed29de3":"3438a73e","chunk-41c0f7a4":"826d3ed3","chunk-426f2f16":"8b0bd32f","chunk-462c869e":"0309c3dc","chunk-47245a33":"76e78edd","chunk-4739acd0":"b9217546","chunk-53b1137a":"d4a035f9","chunk-541ea42d":"56c1e56a","chunk-54bbd082":"75e7d585","chunk-59d4c87c":"2f0c9a00","chunk-5a8ac886":"c026e7b6","chunk-5ff96a24":"fc3acc22","chunk-69eb8776":"2e6247c9","chunk-6d375f34":"3a7f5773","chunk-7548ca2d":"96517214","chunk-79f1dac7":"12825bd4","chunk-8bb7f81e":"d40befe2","chunk-99feb222":"d52facc4","chunk-2f6900da":"415bd2cc","chunk-8688826a":"fcf56a76","chunk-8ee3f4f2":"29d32681","chunk-a9395c36":"b8a0318c","chunk-d0e8aa0a":"3b0d50ba","chunk-d8413eac":"8831e5f9","chunk-e5275ddc":"5aa1af1c","chunk-eaa2b130":"b460437c","polyfills-core-js":"8da452c8","polyfills-dom":"5c1a31ff","stencil-polyfills-css-shim":"54fc0886","stencil-polyfills-dom":"a351dbf1","chunk-2d2297f7":"f0535631","chunk-2d0c9758":"2f901234","chunk-2d0b33e3":"64be60e2","chunk-2d0b9074":"235efaf0","chunk-2d0b9280":"acc735b6","chunk-2d0baac9":"cbb5edf0","chunk-2d2376e6":"a351546d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
